import { CheckCircle2, CircleAlert, Info, TriangleAlert, X } from 'lucide-react'
import { observer } from 'mobx-react-lite'
import { createPortal } from 'react-dom'
import { cn } from '@/lib/cn'
import { useT } from '@/i18n'
import { useStores } from '@/stores'

const icons = { neutral: Info, success: CheckCircle2, danger: CircleAlert, warning: TriangleAlert }
const positions = {
  'bottom-right': 'bottom-4 right-4',
  'top-right': 'top-4 right-4',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2',
  'top-center': 'top-4 left-1/2 -translate-x-1/2',
}
const tones = { neutral: 'text-fg-2', success: 'text-success', danger: 'text-danger', warning: 'text-warning' }

export const Toaster = observer(function Toaster() {
  const { toasts, appearance } = useStores()
  const position = appearance.settings.toastPosition
  const t = useT()
  return createPortal(
    <div
      aria-live="polite"
      data-position={position}
      className={cn(
        'toast-stack pointer-events-none fixed z-[80] flex w-[360px] max-w-[calc(100vw-2rem)] gap-2',
        position.startsWith('top') ? 'flex-col-reverse' : 'flex-col',
        positions[position],
      )}
    >
      {toasts.items.map((toast) => {
        const Icon = icons[toast.tone]
        return (
          <div
            key={toast.id}
            data-state={toast.leaving ? 'closed' : 'open'}
            className="glass-menu motion-toast pointer-events-auto flex items-start gap-3 rounded-[calc(14px*var(--radius-scale))] px-4 py-3">
            <Icon className={cn('mt-0.5 size-4 shrink-0', tones[toast.tone])} aria-hidden />
            <div className="min-w-0 flex-1">
              <p className="text-[length:calc(13.5px*var(--text-scale))] font-medium text-fg">{toast.title}</p>
              {toast.description && <p className="mt-0.5 text-[length:calc(12.5px*var(--text-scale))] text-muted">{toast.description}</p>}
            </div>
            <button
              type="button"
              onClick={() => toasts.dismiss(toast.id)}
              aria-label={t('common.actions.dismiss')}
              className="-mr-1 flex size-6 items-center justify-center rounded-[calc(6px*var(--radius-scale))] text-subtle hover:bg-hover hover:text-fg"
            >
              <X className="size-3.5" />
            </button>
          </div>
        )
      })}
    </div>,
    document.body,
  )
})
